import { render, staticRenderFns } from "./WithoutLabel.vue?vue&type=template&id=1813b72a"
import script from "./WithoutLabel.vue?vue&type=script&lang=js"
export * from "./WithoutLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports